
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import actions from '../js/actions.js';
import $$ from 'Dom7';
export default {
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert('Hello World');
    },
    toogleDiv: async function (id) {
      $("#" + id).slideToggle();
    }
  },
  data: function () {
    return {
      InvoicesData: {}
    };
  },
  on: {
    PageInit: async function (e, page) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var currency = actions.GetUserCurrency();
      var Invoices = await actions.GetInvoices();
      self.$setState({
        InvoicesData: Invoices
      }).then(() => {
        $$(".price-span").text(currency);
      });
    }
  },
  id: '31e6eb1eea',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=reservations><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">';
      r += Template7Helpers.t.call(ctx_1, 'invoices', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class=page-content style=background-color:#f3f3f3;><div class=""><div class=page-content style="background-color:#f7f7f7; padding-top: 20px;"><div class=row><div class=col-50><div class="card left"><div class="card-content card-content-padding takis"><span style="font-size: 13px !important;text-align:center"><b>Today Invoice</b></span><div style="color:#f17049; text-align:center; font-weight: bold;"><span class=price-span></span> ';
      r += c(ctx_1.InvoicesData.InvoicesToday, ctx_1);
      r += '</div></div></div></div><div class=col-50><div class="card right"><div class="card-content card-content-padding takis"><span style="font-size: 13px !important; text-align:center;"><b>Total Payment</b></span><div style="color:#f17049; text-align:center; font-weight: bold;"><span class=price-span></span> ';
      r += c(ctx_1.InvoicesData.PaymentsToday, ctx_1);
      r += '</div></div></div></div><div class=row><div class=col-50><div class="card left"><div class="card-content card-content-padding takis"><span style="font-size: 13px !important;text-align:center"><b>This Month Invoice</b></span><div style="color:#f17049; text-align:center; font-weight: bold;"><span class=price-span></span> ';
      r += c(ctx_1.InvoicesData.InvoicesThisMonth, ctx_1);
      r += '</div></div></div></div><div class=col-50><div class="card right"><div class="card-content card-content-padding takis"><span style="font-size: 13px !important; text-align:center;"><b>This Month Payment</b></span><div style="color:#f17049; text-align:center; font-weight: bold;"><span class=price-span></span> ';
      r += c(ctx_1.InvoicesData.PaymentsThisMonth, ctx_1);
      r += '</div></div></div></div><div class=block-title style="font-weight: bold; color:black; font-size:initial; margin-bottom:7px;">Recent Invoices (Last 30 days)</div><div class=page-content style=width:100%;padding:0;><div class=tabs><div class="tab page-content tab-active" id=invoices-tab><div class="block-title activity" @click="toogleDiv(\'invoicesToday\')">';
      r += Template7Helpers.t.call(ctx_1, 'today', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=list><ul><div id=invoicesToday>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.InvoicesData.InvoicesListToday, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card cardlabel"><div class="card-content card-content-padding takis"><div class=col style="text-align: center;" style=padding:10px!important;><div class=row style="padding-bottom: 5px;"><div class="col-75 infoinvoices" style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.Invoice, ctx_2);
          r += ' (';
          r += c(ctx_2.Room, ctx_2);
          r += ')</div><div class="col-25 infoinvoices" style="font-weight:bold;float: right;text-align: center;"><span class=price-span></span> ';
          r += c(ctx_2.Amount, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.ReservationCustomer, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;font-size: 12px;">';
          r += c(ctx_2.CheckinCheckout, ctx_2);
          r += '</div></div><div class=row><div class="col-50 dateinvoice" style="font-size:13px; color:#9f9595;  font-weight:600;float:left;text-align: left;">';
          r += Template7Helpers.FormatDate.call(ctx_2, 2, ctx_2.CreatedDate, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class="col-25 invoicestatus" style="border-radius:13px;color:green;font-weight: bold;float: right;background-color: ';
          r += c(ctx_2.BackgroundColor, ctx_2);
          r += ';">';
          r += c(ctx_2.Status, ctx_2);
          r += '</div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></ul></div><div class="block-title activity" @click="toogleDiv(\'invoicesYesterday\')">';
      r += Template7Helpers.t.call(ctx_1, 'yesterday', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=list><ul><div id=invoicesYesterday>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.InvoicesData.InvoicesListYesterday, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card cardlabel"><div class="card-content card-content-padding takis"><div class=col style="text-align: center;" style=padding:10px!important;><div class=row style="padding-bottom: 5px;"><div class="col-75 infoinvoices" style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.Invoice, ctx_2);
          r += ' (';
          r += c(ctx_2.Room, ctx_2);
          r += ')</div><div class="col-25 infoinvoices" style="font-weight:bold;float: right;text-align: center;"><span class=price-span></span> ';
          r += c(ctx_2.Amount, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.ReservationCustomer, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;font-size: 12px;">';
          r += c(ctx_2.CheckinCheckout, ctx_2);
          r += '</div></div><div class=row><div class="col-50 dateinvoice" style="font-size:13px; color:#9f9595;  font-weight:600;float:left;text-align: left;">';
          r += Template7Helpers.FormatDate.call(ctx_2, 2, ctx_2.CreatedDate, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class="col-25 invoicestatus" style="border-radius:13px;color:green;font-weight: bold;float: right;background-color: ';
          r += c(ctx_2.BackgroundColor, ctx_2);
          r += ';">';
          r += c(ctx_2.Status, ctx_2);
          r += '</div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></ul></div><div class="block-title activity" @click="toogleDiv(\'invoicesLastWeek\')">';
      r += Template7Helpers.t.call(ctx_1, 'sevendaysbefore', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=list><ul><div id=invoicesLastWeek>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.InvoicesData.InvoicesListLast7Days, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card cardlabel" id=nextbtn><div class="card-content card-content-padding takis"><div class=col style="text-align: center;" style=padding:10px!important;><div class=row style="padding-bottom: 5px;"><div class="col-75 infoinvoices" style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.Invoice, ctx_2);
          r += ' (';
          r += c(ctx_2.Room, ctx_2);
          r += ')</div><div class="col-25 infoinvoices" style="font-weight:bold;float: right;text-align: center;"><span class=price-span></span> ';
          r += c(ctx_2.Amount, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.ReservationCustomer, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;font-size: 12px;">';
          r += c(ctx_2.CheckinCheckout, ctx_2);
          r += '</div></div><div class=row><div class="col-50 dateinvoice" style="font-size:13px; color:#9f9595;  font-weight:600;float:left;text-align: left;">';
          r += Template7Helpers.FormatDate.call(ctx_2, 2, ctx_2.CreatedDate, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class="col-25 invoicestatus" style="border-radius:13px;color:green;font-weight: bold;float: right;background-color: ';
          r += c(ctx_2.BackgroundColor, ctx_2);
          r += ';">';
          r += c(ctx_2.Status, ctx_2);
          r += '</div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></ul></div><div class="block-title activity" @click="toogleDiv(\'invoicesLastMonth\')">';
      r += Template7Helpers.t.call(ctx_1, 'thirtydaysbefore', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=list><ul><div id=invoicesLastMonth>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.InvoicesData.InvoicesListLastMonth, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card cardlabel" id=nextbtn><div class="card-content card-content-padding takis"><div class=col style="text-align: center;" style=padding:10px!important;><div class=row style="padding-bottom: 5px;"><div class="col-75 infoinvoices" style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.Invoice, ctx_2);
          r += ' (';
          r += c(ctx_2.Room, ctx_2);
          r += ')</div><div class="col-25 infoinvoices" style="font-weight:bold;float: right;text-align: center;"><span class=price-span></span> ';
          r += c(ctx_2.Amount, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;">';
          r += c(ctx_2.ReservationCustomer, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style="font-weight:bold;float:left;text-align: left;font-size: 12px;">';
          r += c(ctx_2.CheckinCheckout, ctx_2);
          r += '</div></div><div class=row><div class="col-50 dateinvoice" style="font-size:13px; color:#9f9595;  font-weight:600;float:left;text-align: left;">';
          r += Template7Helpers.FormatDate.call(ctx_2, 2, ctx_2.CreatedDate, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class="col-25 invoicestatus" style="border-radius:13px;color:green;font-weight: bold;float: right;background-color: ';
          r += c(ctx_2.BackgroundColor, ctx_2);
          r += ';">';
          r += c(ctx_2.Status, ctx_2);
          r += '</div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></ul></div></div></div></div></div></div></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};
    